import React, { FC, ReactNode, useState } from "react";

import { useInsuranceLabels } from "../Utils/Context/labelsContext";
import { Modal } from "../Partials/Modal";
import { Button } from "../Partials/Button";
import classNames from "classnames";
import { StreamLineIcon } from "../../SvgIcon/StreamLineIcon";

interface PracticalInformationModalProps {
  label: string;
  body: string | ReactNode;
  className?: string;
}

export const PracticalInformationModal: FC<PracticalInformationModalProps> = (
  props
) => {
  const { label, body, className } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { headings } = useInsuranceLabels();

  return (
    <div className={classNames("practicalInformationModal", className)}>
      <Button
        onClick={() => setIsModalOpen(true)}
        tier="primary"
        type="clear"
        size="small"
        className="practicalInformationModal__button"
      >
        <span className="insuranceButton__label">
          <StreamLineIcon
            className="practicalInformationModal__buttonIcon"
            iconName="s-info-circle"
          />
          <span className="practicalInformationModal__buttonLabel">
            {label}
          </span>
        </span>
      </Button>
      <Modal
        isOpen={isModalOpen}
        ariaLabeledBy="practicalInformationModal-header"
        onClose={() => setIsModalOpen(false)}
        className="practicalInformationModal__inner"
      >
        <h2
          id="practicalInformationModal-header"
          className="practicalInformationModal__header"
        >
          {headings.practicalInfoHeading}
        </h2>
        <div className="practicalInformationModal__body">{body}</div>
      </Modal>
    </div>
  );
};
